// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"538":"recorder","983":"profiler"}[chunkId] || chunkId) + "." + {"250":"04ce5793","538":"22e9af85","983":"73f89a4b"}[chunkId] + ".chunk.js";
};